import { Select } from 'peach/components'
import { useParams } from 'peach/router'

import { useInternalLoanGet, useLoanTypeDynamicFeeGetAll } from 'core/types'

const LoanFeeTypeSelect = ({ loanTypeId, ...rest }) => {
  const { companyId, personId, loanId } = useParams<{
    companyId?: string
    personId?: string
    loanId?: string
  }>()

  const { data: loan } = useInternalLoanGet({
    companyId,
    personId,
    loanId,
  })

  const $loanTypeId = loanTypeId || loan?.loanTypeId

  const { data: dynamicFeeTypes, isLoading } = useLoanTypeDynamicFeeGetAll({
    companyId,
    loanTypeId: $loanTypeId,
  })

  const options = _.map(dynamicFeeTypes, (dynamicFeeType) => {
    const { id, name } = dynamicFeeType
    const { apiName, displayName } = name || {}

    const label = displayName || apiName || id

    const value = apiName

    const note = `${apiName} / ${id}`

    return { label, value, note }
  })

  return (
    <Select
      {...rest}
      label='Dynamic Fee Type'
      loading={isLoading}
      options={options}
      notes
    />
  )
}

export default LoanFeeTypeSelect
